import { render } from "./BaseButton.vue?vue&type=template&id=232e0a07&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=232e0a07&scoped=true&lang=css"

import exportComponent from "D:\\vue-js\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232e0a07"]])

export default __exports__